import type { ChatMetadata } from '../_types/chatMetadata';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const assistantChatMessageSendMutationAtom = createMutationAtomFactory(
  'assistant.chatMessageSend',
  (params: {
    chatId: string;
    content: string;
    fileIds?: string[];
    metadata?: ChatMetadata;
  }) => ({
    assistantSendChatMessage: {
      __args: {
        chatId: params.chatId,
        input: {
          content: params.content,
          fileIds: params.fileIds,
          metadata: params.metadata,
        },
      },
    },
  }),
  {
    skipQueue: false,
    showLoadingOverlay: false,
  },
);
